/**
 * Email intake sandbox.
 *
 * Internal tool for checking how well the AI reads a pasted quote or order
 * email. Results are laid out to mirror the real quote and order forms so a
 * salesperson can see at a glance what would land in each field. It never
 * writes to the CRM.
 */
$(function () {
	var $root = $('#ai-sandbox')

	if (!$root.length) {
		return
	}

	var models = {}
	var documentType = 'quote'
	var lastInputHash = null

	/**
	 * Field layout mirroring the real create forms, so what the reviewer sees
	 * here sits where they expect to find it on the form they already use.
	 */
	var LAYOUT = {
		quote: [
			{
				heading: 'Customer',
				rows: [
					[{ label: 'Customer', key: 'customer_name', width: 6 }, { label: 'Vendor', key: 'vendor_name', width: 6 }],
					[{ label: 'Contact', key: 'contact_name', width: 4 }, { label: 'Contact Email', key: 'contact_email', width: 4 }, { label: 'Contact Phone', key: 'contact_phone', width: 4 }]
				]
			},
			{
				heading: 'Quote Information',
				rows: [
					[{ label: 'Needed By', key: 'requested_ship_date', width: 4 }, { label: 'Ship To', key: 'ship_to', width: 8 }]
				]
			}
		],
		order: [
			{
				heading: 'Customer',
				rows: [
					[{ label: 'Customer', key: 'customer_name', width: 6 }, { label: 'Vendor', key: 'vendor_name', width: 6 }],
					[{ label: 'Contact', key: 'contact_name', width: 4 }, { label: 'Contact Email', key: 'contact_email', width: 4 }, { label: 'Contact Phone', key: 'contact_phone', width: 4 }],
					[{ label: 'Customer Billing Location', key: 'bill_to', width: 6 }, { label: 'Customer Shipping Location', key: 'ship_to', width: 6 }]
				]
			},
			{
				heading: 'Order Information',
				rows: [
					[
						{ label: 'Customer PO', key: 'purchase_order_number', width: 3 },
						{ label: 'Ship Date', key: 'requested_delivery_date', width: 3 },
						{ label: 'Terms', key: 'payment_terms', width: 3 },
						{ label: 'Ship Via', key: 'freight_terms', width: 3 }
					],
					[{ label: 'Contract Referenced', key: 'contract_reference', width: 12 }]
				]
			}
		]
	}

	/**
	 * Line columns mirroring the item rows on each create form.
	 */
	var LINE_COLUMNS = {
		quote: [
			{ label: 'Product', key: 'product_text', width: 4 },
			{ label: 'Price', key: 'target_price', width: 2 },
			{ label: 'Size', key: 'quantity', width: 2 },
			{ label: 'Units', key: 'units', width: 2 },
			{ label: 'Description', key: 'description', width: 2 }
		],
		order: [
			{ label: 'Quantity', key: 'quantity', width: 2 },
			{ label: 'Product', key: 'product_text', width: 4 },
			{ label: 'Units', key: 'units', width: 2 },
			{ label: 'Price', key: 'target_price', width: 2 },
			{ label: 'Description', key: 'description', width: 2 }
		]
	}

	function escapeHtml(value) {
		return $('<div>').text(value === null || value === undefined ? '' : value).html()
	}

	function providerOptions(selected) {
		return Object.keys(models).map(function (provider) {
			return '<option value="' + provider + '"' + (provider === selected ? ' selected' : '') + '>' + provider + '</option>'
		}).join('')
	}

	function modelOptions(provider, selected) {
		var available = models[provider] || {}
		return Object.keys(available).map(function (model) {
			return '<option value="' + model + '"' + (model === selected ? ' selected' : '') + '>' + available[model] + '</option>'
		}).join('')
	}

	function chainRow(provider, model, removable) {
		var $row = $(
			'<div class="form-row ai-sandbox-chain-link mb-1">' +
			'<div class="col-5"><select class="form-control form-control-sm ai-sandbox-provider">' + providerOptions(provider) + '</select></div>' +
			'<div class="col-6"><select class="form-control form-control-sm ai-sandbox-model">' + modelOptions(provider, model) + '</select></div>' +
			'<div class="col-1 px-0">' + (removable ? '<button type="button" class="btn btn-link btn-sm text-danger px-1 ai-sandbox-remove-link" aria-label="Remove">&times;</button>' : '') + '</div>' +
			'</div>'
		)

		$row.on('change', '.ai-sandbox-provider', function () {
			$row.find('.ai-sandbox-model').html(modelOptions($(this).val(), null))
		})

		$row.on('click', '.ai-sandbox-remove-link', function () {
			$row.remove()
		})

		return $row
	}

	function readChain() {
		return $root.find('.ai-sandbox-chain-link').map(function () {
			return {
				provider: $(this).find('.ai-sandbox-provider').val(),
				model: $(this).find('.ai-sandbox-model').val()
			}
		}).get()
	}

	/**
	 * A field the AI could not fill is the reviewer's problem to solve, so make
	 * it obvious rather than rendering an empty box.
	 */
	function fieldClass(field) {
		if (!field || field.value === null || field.value === '') {
			return ' ai-sandbox-blank'
		}

		return field.confidence === 'high' ? '' : ' ai-sandbox-unsure'
	}

	function confidenceNote(field) {
		if (!field || field.value === null || field.value === '') {
			return '<span class="ai-sandbox-flag">Not stated &mdash; needs filling in</span>'
		}

		if (field.confidence === 'high') {
			return ''
		}

		return '<span class="ai-sandbox-flag">' + escapeHtml(field.confidence) + ' confidence &mdash; please check</span>'
	}

	/**
	 * Render one field as a read-only form control, with the email excerpt it
	 * came from underneath it.
	 */
	function renderField(spec, field, hideLabel) {
		var value = field && field.value !== null && field.value !== '' ? escapeHtml(field.value) : ''
		var excerpt = field && field.source_excerpt
			? '<div class="ai-sandbox-excerpt" title="The wording this came from">&ldquo;' + escapeHtml(field.source_excerpt) + '&rdquo;</div>'
			: ''
		var label = hideLabel ? '' : '<label>' + escapeHtml(spec.label) + '</label>'

		return '<div class="col-md-' + spec.width + '">' +
			'<div class="form-group' + fieldClass(field) + '">' + label +
			'<div class="form-control ai-sandbox-readonly">' + value + '</div>' +
			confidenceNote(field) + excerpt +
			'</div></div>'
	}

	function renderLines(structured) {
		var columns = LINE_COLUMNS[documentType]
		var lines = Array.isArray(structured.lines) ? structured.lines : []
		var title = documentType === 'order' ? 'Order Items' : 'Quote Items'
		var html = '<hr><h5>' + title + '</h5>'

		if (!lines.length) {
			return html + '<p class="text-muted">No items were found in this email.</p>'
		}

		html += '<div class="row item">' + columns.map(function (column) {
			return '<div class="col-md-' + column.width + '"><label>' + escapeHtml(column.label) + '</label></div>'
		}).join('') + '</div>'

		lines.forEach(function (line) {
			html += '<div class="row item">' + columns.map(function (column) {
				return renderField(column, line[column.key], true)
			}).join('') + '</div>'
		})

		return html
	}

	function renderForm(structured) {
		var html = ''

		LAYOUT[documentType].forEach(function (section) {
			html += '<h5>' + escapeHtml(section.heading) + '</h5>'
			section.rows.forEach(function (row) {
				html += '<div class="row">' + row.map(function (spec) {
					return renderField(spec, structured[spec.key])
				}).join('') + '</div>'
			})
		})

		html += renderLines(structured)

		if (structured.special_instructions && structured.special_instructions.value) {
			html += '<div class="row"><div class="col-md-12"><div class="form-group">' +
				'<label>Remarks</label>' +
				'<div class="form-control ai-sandbox-readonly ai-sandbox-multiline">' + escapeHtml(structured.special_instructions.value) + '</div>' +
				'</div></div></div>'
		}

		if (Array.isArray(structured.referenced_documents) && structured.referenced_documents.length) {
			html += '<div class="row"><div class="col-md-12"><div class="form-group">' +
				'<label>Referenced Numbers</label>' +
				'<div class="form-control ai-sandbox-readonly">' + structured.referenced_documents.map(escapeHtml).join(', ') + '</div>' +
				'</div></div></div>'
		}

		return html
	}

	function renderRelevance(structured) {
		if (structured.is_relevant === false) {
			return '<div class="alert alert-warning">' +
				'<strong>This does not look like ' + (documentType === 'order' ? 'an order' : 'a quote') + '.</strong> ' +
				escapeHtml(structured.reason) +
				'</div>'
		}

		return ''
	}

	function renderNotes(structured) {
		if (!Array.isArray(structured.notes) || !structured.notes.length) {
			return ''
		}

		return '<div class="alert alert-info">' +
			'<strong><i class="fas fa-exclamation-circle"></i> Please check:</strong>' +
			'<ul class="mb-0 mt-1 pl-3">' + structured.notes.map(function (note) {
				return '<li>' + escapeHtml(note) + '</li>'
			}).join('') + '</ul></div>'
	}

	function renderMeta(run) {
		var usage = run.usage || {}

		return '<dt class="col-5">Model used</dt><dd class="col-7">' + escapeHtml(run.provider) + ' &middot; ' + escapeHtml(run.model) + '</dd>' +
			'<dt class="col-5">Prompt version</dt><dd class="col-7">' + escapeHtml(run.prompt_version) + ' (' + escapeHtml(run.instructions_hash) + ')</dd>' +
			'<dt class="col-5">Time taken</dt><dd class="col-7">' + escapeHtml(run.latency_ms) + ' ms</dd>' +
			'<dt class="col-5">Tokens</dt><dd class="col-7">' + escapeHtml(usage.prompt_tokens) + ' in / ' + escapeHtml(usage.completion_tokens) + ' out</dd>'
	}

	function renderHistory(runs) {
		if (!runs || !runs.length) {
			$root.find('.ai-sandbox-history').html('<p class="text-muted small p-3 mb-0">No runs yet.</p>')
			return
		}

		$root.find('.ai-sandbox-history').html(runs.map(function (run) {
			var status = run.error
				? '<span class="badge badge-danger">error</span>'
				: '<span class="badge badge-light">' + escapeHtml(run.latency_ms) + ' ms</span>'

			return '<div class="ai-sandbox-history-row px-3 py-2">' +
				'<div class="d-flex justify-content-between">' +
				'<span>' + escapeHtml(run.model || 'n/a') + '</span>' + status +
				'</div>' +
				'<div class="text-muted small">' + escapeHtml(run.document_type) + ' &middot; ' +
				escapeHtml(run.prompt_version || '') + ' &middot; ' + escapeHtml(run.created_at || '') + '</div>' +
				'</div>'
		}).join(''))
	}

	function showRun(run) {
		$root.find('.ai-sandbox-empty').attr('hidden', true)
		$root.find('.ai-sandbox-error').attr('hidden', true).text('')

		if (run.error) {
			$root.find('.ai-sandbox-error').removeAttr('hidden').text(run.error)
			$root.find('.ai-sandbox-result').attr('hidden', true)
			return
		}

		lastInputHash = run.input_hash

		$root.find('.ai-sandbox-result-title').text(documentType === 'order' ? 'Draft Order' : 'Draft Quote')
		$root.find('.ai-sandbox-relevance').html(renderRelevance(run.structured))
		$root.find('.ai-sandbox-notes').html(renderNotes(run.structured))
		$root.find('.ai-sandbox-form').html(renderForm(run.structured))
		$root.find('.ai-sandbox-json').text(JSON.stringify(run.structured, null, 2))
		$root.find('.ai-sandbox-meta').html(renderMeta(run))
		$root.find('.ai-sandbox-result').removeAttr('hidden')
	}

	function loadHistory() {
		$.get($root.data('history-url'), lastInputHash ? { input_hash: lastInputHash } : {}).done(renderHistory)
	}

	$root.on('click', '.ai-sandbox-tab', function () {
		$root.find('.ai-sandbox-tab').removeClass('active')
		$(this).addClass('active')
		documentType = $(this).data('document-type')
		lastInputHash = null
		$root.find('.ai-sandbox-result').attr('hidden', true)
		$root.find('.ai-sandbox-empty').removeAttr('hidden')
		loadHistory()
	})

	$root.on('click', '.ai-sandbox-view', function () {
		$root.find('.ai-sandbox-view').removeClass('active')
		$(this).addClass('active')

		var showJson = $(this).data('view') === 'json'
		$root.find('.ai-sandbox-json').attr('hidden', !showJson)
		$root.find('.ai-sandbox-form').attr('hidden', showJson)
	})

	$root.on('click', '.ai-sandbox-toggle-advanced', function () {
		var $advanced = $root.find('.ai-sandbox-advanced')
		var hidden = $advanced.attr('hidden')

		if (hidden) {
			$advanced.removeAttr('hidden')
		} else {
			$advanced.attr('hidden', true)
		}

		$(this).text(hidden ? 'Hide' : 'Show').attr('aria-expanded', hidden ? 'true' : 'false')
	})

	$root.on('click', '.ai-sandbox-add-link', function () {
		$root.find('.ai-sandbox-chain').append(chainRow(Object.keys(models)[0], null, true))
	})

	$root.on('click', '.ai-sandbox-run', function () {
		var $button = $(this)
		var data = new FormData()

		data.append('document_type', documentType)
		data.append('body', $root.find('.ai-sandbox-input').val())

		readChain().forEach(function (link, index) {
			data.append('failover[' + index + '][provider]', link.provider)
			data.append('failover[' + index + '][model]', link.model)
		})

		var file = $root.find('.ai-sandbox-attachment')[0].files[0]
		if (file) {
			data.append('attachment', file)
		}

		$button.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Reading...')

		$.ajax({
			url: $root.data('run-url'),
			method: 'POST',
			data: data,
			processData: false,
			contentType: false,
			headers: { 'X-CSRF-TOKEN': window.Laravel.csrfToken }
		}).done(function (response) {
			showRun(response.run)
			loadHistory()
		}).fail(function (xhr) {
			var payload = xhr.responseJSON || {}
			var message = payload.message || 'The extraction failed.'

			if (payload.errors) {
				message = Object.keys(payload.errors).map(function (key) {
					return payload.errors[key].join(' ')
				}).join(' ')
			}

			$root.find('.ai-sandbox-empty').attr('hidden', true)
			$root.find('.ai-sandbox-error').removeAttr('hidden').text(message)
			$root.find('.ai-sandbox-result').attr('hidden', true)
			loadHistory()
		}).always(function () {
			$button.prop('disabled', false).html('<i class="fas fa-play"></i> Read this email')
		})
	})

	$.get($root.data('config-url')).done(function (response) {
		models = response.models || {}

		var chain = response.default_chain || {}
		var $chain = $root.find('.ai-sandbox-chain').empty()

		Object.keys(chain).forEach(function (provider, index) {
			$chain.append(chainRow(provider, chain[provider], index > 0))
		})

		if (!$chain.children().length) {
			$chain.append(chainRow(Object.keys(models)[0], null, false))
		}

		renderHistory(response.history)
	})
})
